import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
export const withAutoHide = (ComposedComponent, propName = 'show') => {
    const WrappedComponent = (props, ref) => {
        const [shown, setShown] = useState(props[propName]);
        const [timer, setTimer] = useState(undefined);
        const show = (hideAfter) => {
            clearTimeout(timer);
            setShown(true);
            const timerId = setTimeout(() => {
                setShown(false);
            }, hideAfter || props.hideAfter || 3500);
            setTimer(timerId);
        };
        const hide = () => {
            clearTimeout(timer);
            setShown(false);
            setTimer(undefined);
        };
        useEffect(() => {
            if (shown) {
                show(props.hideAfter);
            }
        }, []);
        useImperativeHandle(ref, () => ({ show, hide }), [timer]);
        return (<ComposedComponent {...props} {...{ [propName]: shown }}/>);
    };
    return forwardRef(WrappedComponent);
};
